import { useState } from 'react';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-3 max-w-3xl mx-auto">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden hover:border-pink-300 dark:hover:border-pink-700 transition-colors"
          >
            <button
              onClick={() => toggle(index)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between px-5 py-4 text-left"
            >
              <span className="text-sm sm:text-base font-medium text-gray-800 dark:text-gray-100 pr-4">
                {item.question}
              </span>
              {isOpen ? (
                <CaretUp size={18} className="text-gray-500 dark:text-gray-400 flex-shrink-0" />
              ) : (
                <CaretDown size={18} className="text-gray-500 dark:text-gray-400 flex-shrink-0" />
              )}
            </button>
            {isOpen && (
              <div className="px-5 pb-4">
                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
